































import { Component, Vue } from 'vue-property-decorator'
import SlamTableEntry from '@/types/SlamTableEntry'
import DamageLimit from '@/types/DamageLimit'
import Dice from '@/types/Dice'
import Range from '@/types/Range'

@Component
export default class SlamTableCalculator extends Vue {
  hp = 10
  slamTable: Array<SlamTableEntry> = []

  private static untilSpeed = 35
  private static initialDamageLimits: Array<DamageLimit> = [ // see B371
    { dice: new Dice(1, -3), limit: 25 },
    { dice: new Dice(1, -2), limit: 50 },
    { dice: new Dice(1, -1), limit: 100 },
    { dice: new Dice(1), limit: 150 }
  ]

  mounted (): void {
    this.calculate()
  }

  calculate (): void {
    if (this.hp < 1) {
      this.hp = 1
    }

    let table: Array<SlamTableEntry> = []
    let currentSpeed = 1

    for (const damageLimit of this.getDamageLimitsUntilSpeed(SlamTableCalculator.untilSpeed)) {
      let currentRange = new Range()

      while (this.hp * currentSpeed < damageLimit.limit) {
        currentRange.expandTo(currentSpeed)
        currentSpeed++
      }

      table.push({ speedRange: currentRange, damage: damageLimit.dice })
    }

    this.slamTable = table
  }

  private getDamageLimitsUntilSpeed (speed: number): Array<DamageLimit> {
    let damageLimits = [...SlamTableCalculator.initialDamageLimits]

    while (damageLimits[damageLimits.length - 1].limit <= this.hp * speed) {
      const lastDamageLimit = damageLimits[damageLimits.length - 1]
      // see B371
      let nextDice = new Dice(lastDamageLimit.dice.count + 1)
      let nextLimit = lastDamageLimit.limit + 100
      damageLimits.push({ limit: nextLimit, dice: nextDice })
    }
    return damageLimits
  }
}
